module.exports = __webpack_public_path__ + "img/whats-new-9_jp.4ec5e92.jpg";